module.exports = __webpack_public_path__ + "img/article.ee9a7f01.svg";